import { observer } from "mobx-react";
import React from "react";
import {
  Modal,
  Button,
  Text,
  Group,
  rem,
  Card,
  Image,
  Center,
  Alert,
} from "@mantine/core";
import { Cubby } from "../stores/Cubby";
import { IconAlertTriangle } from "@tabler/icons-react";

const YouHaveBeenDisconnected = observer(({ cubby }: { cubby: Cubby }) => {
  const handleReload = () => {
    window.location.href = "/node";
  };

  return (
    <>
      <Center>
        <Card>
          <Image
            h={40}
            style={{ display: "block" }}
            mb="-.5rem"
            src="https://daxwktpz4hkwd.cloudfront.net/logos/rizful-logo-mobile.png"
            alt="Rizful logo"
          />

          <Center maw={400} h={400}>
            <Alert icon={<IconAlertTriangle size={36} />}>
              <Text size="lg">
                You've been disconnected. Please reload the page to use Rizful.
              </Text>
              <Button mt="lg" variant="filled" onClick={handleReload}>
                Reload Page
              </Button>
            </Alert>
          </Center>
        </Card>
      </Center>
    </>
  );
});

export default YouHaveBeenDisconnected;
